var _defs, _path, _polygon, _polyline, _line, _path2, _path3, _path4, _polygon2, _path5, _path6, _path7, _polygon3, _path8, _path9, _path10, _polygon4, _path11, _path12, _path13, _polygon5, _line2, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBachelorPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0aadd6;}.cls-2{fill:#2f2d3b;}.cls-3{fill:none;stroke:#2f2d3b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4{fill:#e6e7e8;}.cls-5{fill:#2992cc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45,17.67l5.18-1.73,1.82,20.06-1.32-.48c-6.15-2.24-12.96-1.7-18.68,1.48-5.72-3.18-12.53-3.72-18.68-1.48l-1.32,.48,1.82-20.06,18.18,6.06,9-3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62 12 32 22 2 12 32 2 62 12"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "45 17.67 62 12 32 2 2 12 32 22 41 19"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 47.49,
    y1: 30.55,
    x2: 46.72,
    y2: 22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55,55h-17c-3.87,0-5-3.13-5-7h15c0,3.87,3.13,7,7,7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62,48c0,3.87-3.13,7-7,7s-7-3.13-7-7h6c0-2.21,1.79-4,4-4s4,1.79,4,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,55h-7c-3.87,0-5-3.13-5-7s1.13-7,5-7h7c-3.87,0-5,3.13-5,7s1.13,7,5,7Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36 55 36 62 33 60 30 62 30 55 36 55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,55h-7c-3.87,0-5-3.13-5-7s1.13-7,5-7h7c-3.87,0-5,3.13-5,7s1.13,7,5,7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31,55H9c-3.87,0-7-3.13-7-7H26c0,3.87,1.13,7,5,7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58,44c-2.21,0-4,1.79-4,4h-6c0-1.49,.46-2.87,1.25-4h8.75Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "36 55 36 62 33 60 30 62 30 55 36 55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,55h8c-3.87,0-7-3.13-7-7,0-1.49,.46-2.87,1.25-4h.01c1.26-1.82,3.36-3,5.74-3h-17c-3.87,0-5,3.13-5,7s1.13,7,5,7h5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62,48c0,3.87-3.13,7-7,7s-7-3.13-7-7h6c0-2.21,1.79-4,4-4s4,1.79,4,4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38,55h-7c-3.87,0-5-3.13-5-7s1.13-7,5-7h7c-3.87,0-5,3.13-5,7s1.13,7,5,7Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "36 55 36 62 33 60 30 62 30 55 36 55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38,55h-7c-3.87,0-5-3.13-5-7s1.13-7,5-7h7c-3.87,0-5,3.13-5,7s1.13,7,5,7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16,41h15c-3.87,0-5,3.13-5,7s1.13,7,5,7H9c-3.87,0-7-3.13-7-7s3.13-7,7-7h3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58,44c-2.21,0-4,1.79-4,4h-6c0-1.49,.46-2.87,1.25-4h8.75Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "36 55 36 62 33 60 30 62 30 55 36 55"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5,
    y1: 25,
    x2: 5,
    y2: 13
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,25c-1.66,0-3,1.34-3,3v7h3v-10Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5,25h0c1.66,0,3,1.34,3,3v7H2v-7c0-1.66,1.34-3,3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBachelorPrograms);
export default __webpack_public_path__ + "static/media/bachelor_programs.22b91a04c83e10da9a08809b320551b7.svg";
export { ForwardRef as ReactComponent };